import { Stack, type SxProps } from "@mui/material";
import { ErrorPageTemplate } from "@src/appV2/Errors/Template";
import { ClipboardLogo } from "@src/appV2/lib/Content";

import { Button } from "../../components/Button";

interface AddRolesErrorStateProps {
  sx?: SxProps;
}

export function AddRolesErrorState(props: AddRolesErrorStateProps) {
  const { sx } = props;

  return (
    <ErrorPageTemplate
      sx={sx}
      illustration={<ClipboardLogo />}
      title="We're having trouble loading roles"
      description="Please try again"
      actions={
        <Stack spacing={4} width="100%">
          <Button
            fullWidth
            variant="contained"
            size="large"
            onClick={() => {
              globalThis.location.reload();
            }}
          >
            Reload page
          </Button>
        </Stack>
      }
    />
  );
}
